import { Search, Bell, Sun, Moon, LogOut, Award } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

const Header = ({ onLogout }) => {
  const { dark, toggleTheme } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();

  const bgSidebar = dark ? '#1E293B' : '#FFFFFF';
  const txtPrimary = dark ? '#F1F5F9' : '#0F172A';
  const txtSecondary = dark ? '#94A3B8' : '#64748B';

  return (
    <header style={{
      height: 56, minHeight: 56, display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', padding: '0 24px',
      background: bgSidebar, borderBottom: `1px solid ${dark ? '#334155' : '#E2E8F0'}`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <div style={{ position: 'relative', width: 280 }}>
          <Search size={15} style={{ position: 'absolute', left: 10, top: 9, color: txtSecondary }} />
          <input placeholder="Global search..." style={{
            width: '100%', padding: '8px 12px 8px 34px', borderRadius: 8,
            border: `1px solid ${dark ? '#475569' : '#D1D5DB'}`,
            background: dark ? '#0F172A' : '#F8FAFC',
            color: txtPrimary, fontSize: 13, outline: 'none',
          }} />
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {user?.role?.code === 'COUNSELLOR' && (
          <div title="Performance points earned from Admission Confirmed leads" style={{
            display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px',
            borderRadius: 20,
            background: dark ? '#F59E0B1A' : '#FEF3C7',
            border: `1px solid ${dark ? '#F59E0B40' : '#FDE68A'}`,
          }}>
            <Award size={14} color="#F59E0B" />
            <span style={{ fontSize: 12, fontWeight: 700, color: dark ? '#FBBF24' : '#B45309' }}>
              {user.performancePoints || 0} pts
            </span>
          </div>
        )}

        <button onClick={toggleTheme} style={{ background: 'none', border: 'none', cursor: 'pointer', color: txtSecondary, padding: 6 }}>
          {dark ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        <button onClick={() => navigate('/notifications')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: txtSecondary, padding: 6, position: 'relative' }}>
          <Bell size={18} />
          <div style={{ position: 'absolute', top: 2, right: 2, width: 8, height: 8, borderRadius: 4, background: '#EF4444' }} />
        </button>

        <div style={{ width: 1, height: 24, background: dark ? '#334155' : '#E2E8F0' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: 'linear-gradient(135deg,#3B82F6,#8B5CF6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontWeight: 700, fontSize: 12,
          }}>
            {user?.firstName?.[0]}{user?.lastName?.[0] || ''}
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: txtPrimary, lineHeight: 1.2 }}>
              {user?.firstName} {user?.lastName || ''}
            </div>
            <div style={{ fontSize: 11, color: txtSecondary }}>{user?.role?.name || 'User'}</div>
          </div>
        </div>

        <button onClick={onLogout} title="Logout" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#EF4444', padding: 6 }}>
          <LogOut size={17} />
        </button>
      </div>
    </header>
  );
};

export default Header;
